import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { ComponentPropsWithRef } from '../../types/utils';
import { getInputClassName, InputClassProps } from '../input-class-name.util';

type TextareaOwnProps = {
  nonResizable?: boolean;
} & InputClassProps;

export type TextareaProps = ComponentPropsWithRef<'textarea'> &
  TextareaOwnProps;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea(
    {
      className,
      variant,
      disabled,
      readOnly,
      hasError = false,
      fullWidth = true,
      nonResizable = false,
      children,
      ...rest
    },
    ref
  ) {
    return (
      <textarea
        ref={ref}
        disabled={disabled}
        readOnly={readOnly}
        aria-invalid={hasError || undefined}
        className={classNames(
          getInputClassName({
            variant,
            disabled: disabled || readOnly,
            hasError,
            fullWidth,
          }),
          { 'resize-none': nonResizable },
          className
        )}
        {...rest}
      >
        {children}
      </textarea>
    );
  }
);
